import React from 'react';

const Space = () => {
  return (
    <div className='flex1'/>
  )
}

export default Space;